// extracted by mini-css-extract-plugin
export var linebreak = "NDSTemplateIntro-module--linebreak--16670";
export var ndsIntroTemplateBody = "NDSTemplateIntro-module--ndsIntroTemplateBody--94325";
export var ndsIntroTemplateContainer = "NDSTemplateIntro-module--ndsIntroTemplateContainer--8fa2a";
export var ndsIntroTemplateHeader = "NDSTemplateIntro-module--ndsIntroTemplateHeader--e0cf1";
export var ndsIntroTemplateHeaderTitle = "NDSTemplateIntro-module--ndsIntroTemplateHeaderTitle--09a81";
export var ndsIntroTemplateImage = "NDSTemplateIntro-module--ndsIntroTemplateImage--10b92";
export var option = "NDSTemplateIntro-module--option--b4c9f";
export var visuallyHidden = "NDSTemplateIntro-module--visuallyHidden--ed5ee visuallyHidden-module--visuallyHidden--0fa26";